import Box from '@sendsprint/ui-react/dist/components/Box';
import React from 'react';
import PageNav from '../stepFormComponents/pageNav';
import useMultiForm from './state/useMultiForm';
import { FormVariantsI } from './state';
import GetPaymentMethods from '../paymentDropdownList/components/getPaymentMethods';
import SendMoneySteps from './components/sendMoneySteps';
import StepFormExtraComponents from '../stepFormComponents/stepFormExtraComponents';
import Meta from '../meta';

interface Props {
  variant?: FormVariantsI;
}

const SendMoneyFlow = ({ variant = 'send money' }: Props) => {
  const pageViewName = variant === 'transfer schedule' ? 'Add Scheduled Transfer' : 'Send Money';

  const multiFormResponse = useMultiForm({
    variant,
    pageViewName
  });

  const {
    state,
    goToHandler,
    markPageAsClean,
    handlePaymentMethods,
    isLoggedIn,
    navigateToStep,
    closeLeavingStepDialog,
    markPageAllAsClean
  } = multiFormResponse;

  return (
    <>
      <Meta pageTitle={pageViewName} />
      <Box className="ss-mb-5">
        <PageNav
          steps={state.steps}
          currentIndex={state.currentIndex}
          maxActiveIndex={state.maxActiveIndex}
          goTo={goToHandler}
        />
      </Box>
      <GetPaymentMethods
        handlePaymentMethods={handlePaymentMethods}
        senderInitials={state.amountFormData?.sendCountry || ''}
      />
      <SendMoneySteps multiFormResponse={multiFormResponse} variant={variant} />
      <StepFormExtraComponents
        closeLeavingStepDialog={closeLeavingStepDialog}
        leavingStepDialogNextIndex={state.leavingStepDialogNextIndex}
        markPageAsClean={markPageAsClean}
        navigateToStep={navigateToStep}
        routeLeavingGuardWhen={state.isPageDirty && isLoggedIn}
        showLeavingStepDialog={state.showLeavingStepDialog}
        markPageAllAsClean={markPageAllAsClean}
      />
    </>
  );
};

export default SendMoneyFlow;
